import React from 'react';

const PeopleCollectionsIcon = () => (
  <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9167 1.65H5.95833L4.875 0H1.08333C0.485333 0 0 0.4928 0 1.1V9.9C0 10.5072 0.485333 11 1.08333 11H11.9167C12.5147 11 13 10.5072 13 9.9V2.75C13 2.1428 12.5147 1.65 11.9167 1.65ZM8.66667 7.15H7.04167V8.8C7.04167 9.1025 6.79792 9.35 6.5 9.35C6.20208 9.35 5.95833 9.1025 5.95833 8.8V7.15H4.33333C4.03542 7.15 3.79167 6.9025 3.79167 6.6C3.79167 6.2975 4.03542 6.05 4.33333 6.05H5.95833V4.4C5.95833 4.0975 6.20208 3.85 6.5 3.85C6.79792 3.85 7.04167 4.0975 7.04167 4.4V6.05H8.66667C8.96458 6.05 9.20833 6.2975 9.20833 6.6C9.20833 6.9025 8.96458 7.15 8.66667 7.15Z" fill="#104665" />
  </svg>
);

export default PeopleCollectionsIcon;
